<template>
  <UIDialog
    :is-open
    :z-index
    @close="handleClose"
  >
    <div class="account-akoya__content">
      <div class="account-akoya__logo">
        <img :src="logoSrc" />
      </div>
      <div class="account-akoya__text">
        You are connecting to {{ name }} account using Akoya
      </div>
    </div>
    <UICheckbox
      v-model="agreement"
      label="I have read and agreed to the following terms of the account information
        sharing. Account information is retrieved via Akoya Data Access Network.
        The information includes account balances and positions. The information
        is retrieve only. The information will not be shared, rented, exchanged
        or sold without your consent."
      class="account-akoya__agreement"
    />
    <template #footer>
      <UIButtonsGroup>
        <UIButton
          label="Cancel"
          variant="gray"
          fill="outlined"
          @click="handleCancel"
        />
        <UIButton v-bind="{ disabled }" label="Next" @click="handleClickNext" />
      </UIButtonsGroup>
    </template>
  </UIDialog>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'

import { ModalClass } from '@types'

import { INSTITUTION_LOGO_PLACEHOLDER } from '../../utils/const'

import { UIDialog } from '@ui/modals'
import { UIButton, UIButtonsGroup } from '@ui/buttons'
import { UICheckbox } from '@ui/controllers'

type Props = {
  modal: ModalClass<any>
  name: string
  url: string
  logo?: string | null
}

type Emits = {
  cancel: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const agreement = ref(false)

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const disabled = computed(() => !agreement.value || !props.url)

const logoSrc = computed<string>(
  () => props.logo || INSTITUTION_LOGO_PLACEHOLDER,
)

const handleClose = () => {
  props.modal.close()
  agreement.value = false
}

const handleCancel = () => {
  handleClose()
  emit('cancel')
}

const handleClickNext = () => {
  if (!props.url) return
  location.href = props.url
}
</script>

<style scoped>
.account-akoya {
  &__content {
    @apply flex flex-col items-center;
    @apply mb-8;
  }

  &__text {
    @apply text-stone-950 dark:text-gray-300;
    @apply text-center;
  }

  &__logo {
    @apply h-24;
    @apply mb-4;
    @apply bg-white;

    img {
      @apply w-full h-full;
      @apply object-contain;
    }
  }

  &__agreement {
    @apply mb-1;

    .ui-checkbox__label {
      @apply font-medium text-sm sm:text-xs;
    }
  }
}
</style>
